<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/idEydm/tc-custom/9789948746454.jpg?1725723409108" alt="This image is the cover for the book سر الأنوثة"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">سر الأنوثة
      </h1>
      <p class="bookDescription body article font2">
        <p>اكتشفي سِرَّ الأنوثة مع "سرّ الأنوثة: دليل الإتيكيت للثقة والأناقة" الكتاب المُلهم يكشف لكِ عن قوَّتك الحقيقيَّة كامرأة، ويساعِدك في احتضان جاذبيَّة داخليَّة مُشعَّة بالثقة والسكينة والأناقة.. مِن خلال نصائح فعَّالة وممارسات عمليَّة، ستُتقنين فنَّ التواصل، وتحتضنين جمالَك الفريد، وتتألَّقين بالثقة في أيِّ موقف. الأنوثة الحقيقيَّة لا تقتصر على الجمال الخارجيِّ، بل تشمل القوة الداخلية، والمرونة، وحب الذات.  كلُّ فصل في "سرّ الأنوثة" يُلهمك لتتخلَّصي منَ الشكوك، وتحتضني أصالتك، وتخطي خطوات واثقة نحو القوَّة الداخليَّة كامرأة بتنمية الإتيكيت جنبًا إلى جنب، مع نمُوِّك الشخصيِّ ستكتشفين توليفة قويَّة ترتقي بحضورك في كلِّ جانب من جوانب حياتك. هذا الدليل هو رفيقك الوَفيّ! سواء كنتِ في بداية رحلة تطوير حياتك الشخصيَّة والمهنيَّة أو نهايتها. في صفحاته.. ستجِدين المفاتيح الَّتي تفتح لكِ أبواب الأنوثة الحقيقيَّة وتعيشين حياة مليئة بالهدف والشَّغف والأناقة.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        سميرة حمادي
      </h2>
      
      <p class="authorDescription body article">سميرة حمادي، كاتبة، ومُستشارة في (الإتيكيت)، ومُدرِّبةُ حياةٍ مُعتَمَدة مِن معهَد (إميلي بوست). هي أيضًا مُؤسِّسةُ شركةِ استشاراتِ (الإتيكيت) الحديثة؛ حيثُ تُقدِّم استشاراتٍ وتدريباتٍ للمؤسَّسات والأفرادِ مِن جميع الأعمارِ حولَ فنِّ (الإتيكيت)، والمهاراتِ الشّخصيَّةِ، بالإضافة إلى ذلك، هي أيضًا طيَّارةٌ مُعترَفٌ بها.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e0ceaee